// Homepage headline experiment (compliant control vs compliant alternative).
// The retired claim-heavy page is NOT part of this experiment.
//
// Pre-registered plan (set before launch; do not change mid-test):
//   Primary outcome    compliance review request submitted (unique visitors / exposed visitors)
//   Secondary outcome  Health Score completed (unique visitors / exposed visitors)
//   Downstream outcome human-qualified inquiry (service fit + relevant need + valid contact)
//   Fixed target       TARGET_PER_ARM exposed unique visitors in EACH arm before any assessment
//   Min. worthwhile    MIN_EFFECT_POINTS absolute percentage points on the primary outcome
//   Sizing assumption  ~4% baseline review-request rate; detecting a 2-point change at ~80% power
//                      (alpha 0.05) needs roughly 1,500 visitors per arm. Re-check the baseline
//                      against real data; if it is far lower, the target must be raised BEFORE launch.

export const EXPERIMENT = {
  id: "headline_ab_v1",
  variants: ["control", "headline_b"],
  labels: { control: "Control (current headline)", headline_b: "Alternative headline" },
  targetPerArm: 1500,
  minEffectPoints: 2,
};

const VARIANT_KEY = "lc_exp_headline_ab_v1";
const VISITOR_KEY = "lc_exp_visitor_id";
const EXPOSED_KEY = "lc_exp_headline_ab_v1_exposed";

const read = (k) => {
  try { return localStorage.getItem(k); } catch { return null; }
};
const write = (k, v) => {
  try { localStorage.setItem(k, v); } catch { /* storage blocked: assignment will not persist */ }
};

export function getVariant() {
  const v = read(VARIANT_KEY);
  return EXPERIMENT.variants.includes(v) ? v : null;
}

export function getVisitorId() {
  let id = read(VISITOR_KEY);
  if (!id) {
    id = crypto.randomUUID();
    write(VISITOR_KEY, id);
  }
  return id;
}

// Random 50/50 assignment, made once per browser and then kept.
export function assignVariant() {
  let v = getVariant();
  if (!v) {
    v = crypto.getRandomValues(new Uint8Array(1))[0] % 2 === 0 ? EXPERIMENT.variants[0] : EXPERIMENT.variants[1];
    write(VARIANT_KEY, v);
  }
  return v;
}

// Entity events carry a pseudonymous visitor id and variant only; no name/email.
// Skipped when the visitor never saw the homepage (no assigned variant).
export async function logExperimentEvent(base44, eventType, extra = {}) {
  const variant = getVariant();
  if (!variant) return;
  if (eventType === "exposure") {
    if (read(EXPOSED_KEY)) return;
    write(EXPOSED_KEY, "1");
  }
  await base44.entities.HomeExperimentEvent.create({
    experiment_id: EXPERIMENT.id,
    variant,
    visitor_id: getVisitorId(),
    event_type: eventType,
    ...extra,
  }).catch(() => {});
}